// utils.js
const convertToWei = (amount, decimals = 18) => {
    if (typeof amount !== 'string' && typeof amount !== 'number') {
        throw new Error('Amount must be a string or number');
    }
    const amountStr = typeof amount === 'string' ? amount : amount.toString();
    const [integerPart, fractionalPart = ''] = amountStr.split('.');
    const paddedFractionalPart = fractionalPart.padEnd(decimals, '0');
    return BigInt(integerPart + paddedFractionalPart);
};

const convertFromWei = (amount, decimals = 18, displayDecimals = 18) => {
    const amountBigInt = BigInt(amount);
    const divisor = BigInt(10 ** decimals);
    const integerPart = amountBigInt / divisor;
    const fractionalPart = amountBigInt % divisor;
    const paddedFractionalPart = fractionalPart.toString().padStart(decimals, '0');
    const result = `${integerPart}.${paddedFractionalPart.slice(0, displayDecimals)}`;
    return parseFloat(result);
};

const formatNumberWithCommas = (number, decimalPlaces = 2) => {
    if (number === undefined || number === null) {
        return '0';
    }
    // 處理 BigInt
    if (typeof number === 'bigint') {
        number = number.toString();
    }
    // 處理純數字字串
    if (typeof number === 'string' && /^\d+$/.test(number)) {
        number = Number(number);
    }
    if (isNaN(number)) return '0';
    let num = Number(number);
    if (isNaN(num)) return '0';
    const parts = num.toFixed(decimalPlaces).split('.');
    const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPlaces > 0 ? `${formattedInteger}.${parts[1]}` : formattedInteger;
};

export default {
    convertToWei,
    convertFromWei,
    formatNumberWithCommas
};